require('./bootstrap');

import Vue from "vue"
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import router from './router'
import store from './store'
import VueCountdownTimer from 'vuejs-countdown-timer'

Vue.use(VueCountdownTimer)

Vue.use(Vuelidate)
Vue.use(VueAxios, axios)


new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#vitrine')
